// extracted by mini-css-extract-plugin
export var container = "_aj-0";
export var icon = "_aj-1";
export var text = "_aj-2";